import { render, staticRenderFns } from "./TestContest.vue?vue&type=template&id=a5f24652"
import script from "./TestContest.vue?vue&type=script&lang=js"
export * from "./TestContest.vue?vue&type=script&lang=js"
import style0 from "./TestContest.vue?vue&type=style&index=0&id=a5f24652&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports